import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=79f2eb1c&scoped=true"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"
import style0 from "./AlertDetails.vue?vue&type=style&index=0&id=79f2eb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f2eb1c",
  null
  
)

export default component.exports